import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute() {
    const { session, loading } = useAuth();
    if (loading) {
        return (
            <div
                data-testid="auth-loading"
                className="min-h-screen flex items-center justify-center bg-background text-sm text-muted-foreground"
            >
                Chargement de la session…
            </div>
        );
    }
    return session ? <Outlet /> : <Navigate to="/login" replace />;
}
